import { capabilities } from '../../capabilities';
import { getPortalId } from '../../common/utils';
import { defineComponent } from '../../platform/models';
import { ACADEMY_TOOLBAR_COMPONENT } from '../constants';
import { args } from '../../common/args';
export const ACADEMY_TOOLBAR_COMPONENT_ID = 'academy-toolbar';
export const academyToolbarNavComponentDef = defineComponent(ACADEMY_TOOLBAR_COMPONENT, {
  name: ACADEMY_TOOLBAR_COMPONENT,
  path: `/academy-navigation-components/${getPortalId()}/toolbar`,
  capabilities: [capabilities.SHOW_COMPONENT_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.NAVIGATE_TO_CAP.getName()],
  iframeProps: {
    id: ACADEMY_TOOLBAR_COMPONENT_ID,
    ['data-test-id']: ACADEMY_TOOLBAR_COMPONENT_ID,
    style: {
      width: '100%',
      height: '56px',
      overflow: 'hidden',
      backgroundColor: '#6a78d1'
    }
  },
  propsSchema: {
    name: args.string(),
    id: args.number(),
    lessonId: args.number(),
    trackId: args.optional(args.number()),
    portalId: args.number(),
    sourcePortalId: args.optional(args.number()),
    isInstructionsPopoverOpen: args.optional(args.bool()),
    isManuallyGraded: args.optional(args.bool()),
    isSimulation: args.optional(args.bool())
  },
  initialProps: {
    name: '',
    id: 0,
    lessonId: 0,
    trackId: undefined,
    portalId: 0,
    sourcePortalId: 0,
    isInstructionsPopoverOpen: false,
    isManuallyGraded: false,
    isSimulation: false
  },
  initiallyOpen: false,
  deferLoading: true,
  renderTo: () => {
    const academyToolbarId = `${ACADEMY_TOOLBAR_COMPONENT_ID}-renderTo`;
    const existingTarget = document.querySelector(`#${academyToolbarId}`);
    if (existingTarget) {
      return existingTarget;
    }
    const navElement = document.querySelector('#hs-nav-v4');
    const academyToolbar = document.createElement('div');
    academyToolbar.id = academyToolbarId;
    if (navElement) {
      navElement.insertBefore(academyToolbar, navElement.firstChild);
    }
    return academyToolbar;
  }
});